import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionSummary } from "@mui/material";
import { uniqueId } from "lodash";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { sourceList } from "utils/CommonConstants";
import { functionalAreaIdsToNames } from "utils/CommonFunctions";
import Typography from "../Typography";
import { fetchFilterSelectedPlansAsync } from "./Filters.slice";

const FilterDescription = () => {
  const dispatch = useAppDispatch();
  const [filterList, setFilterList] = useState<any[]>([]);
  const [expanded, setExpanded] = useState(false);
  const [listShowMore, setListShowMore] = useState<any>({});
  const { filterCategories, filters, planInfo } = useAppSelector((state) => state.filters);
  const ownerInfo: any = useAppSelector((state) => state.filters.ownerInfo);

  useEffect(() => {
    const fetchData = async () => {
      const resolvedList = await Promise.all(
        filters?.map(async (item: any) => {
          try {
            const optionRes = await getFilterOptions(item?.key, item?.options);
            return {
              ...item,
              options: optionRes
            };
          } catch (error) {
            return {
              ...item,
              options: []
            };
          }
        })
      );
      setFilterList(resolvedList);
    };
    fetchData();
  }, [filters]);

  const getFilterOptions = async (key: string, options: string[]) => {
    let optionsRes: string[] = [];
    switch (key) {
      case "brandCode": {
        const valueToPickFrom = filterCategories?.find((fil: any) => fil?.key === key)?.filters;
        optionsRes = options?.map((item: any) => valueToPickFrom?.find((val: any) => val?.key === item)?.value);
        break;
      }
      case "planSource": {
        optionsRes = sourceList?.filter((item: any) => options?.includes(item.value[0]))?.map((val: any) => val?.name);
        break;
      }
      case "functionalAreaId": {
        optionsRes = functionalAreaIdsToNames(options);
        break;
      }
      case "planOwner": {
        optionsRes = options?.map((item: any) => ownerInfo?.find((item2: any) => item2?.id === item)?.name);
        break;
      }
      case "planCmsId": {
        const filtered = options?.filter((item: string) => planInfo?.findIndex((prop: any) => prop.id === item) < 0);
        let plansData = planInfo;
        if (filtered?.length) {
          const data: any = await dispatch(
            fetchFilterSelectedPlansAsync({
              payload: {
                filter: {
                  ids: filtered
                }
              }
            })
          );
          plansData = [...plansData, ...(data?.payload?.plans ?? [])];
        }
        optionsRes = resolvePlanName(options, plansData);
        break;
      }
      default: {
        optionsRes = options;
      }
    }
    return optionsRes;
  };

  const resolvePlanName = (options: string[], planInfo: any) => {
    return options?.map((item: any) => planInfo?.find((planValue: any) => planValue?.id === item)?.name);
  };

  const handleChange = () => {
    setExpanded(!expanded);
  };

  const getSliceNoToShowRecord = (item: any) => {
    return listShowMore[item.key] || 10;
  };

  const handleShowMoreClick = (itemkey: string, length: number) => {
    setListShowMore({ ...listShowMore, [itemkey]: length });
  };

  const getMoreOrLessButton = (label: string, item: any, isSeeLess: boolean) => {
    return (
      <Typography
        showBold
        sx={{ textDecoration: "underline", cursor: "pointer" }}
        color={tokens.Text.General.Color}
        variant={"label"}
        onClick={(event: any) => {
          event.stopPropagation();
          handleShowMoreClick(item.key, isSeeLess ? 10 : item?.options?.length);
        }}
      >
        {label}
      </Typography>
    );
  };

  return (
    <>
      {filters?.length > 0 && (
        <Accordion
          expanded={expanded}
          onChange={handleChange}
          sx={{
            backgroundColor: tokens.Background.General.Secondary,
            borderRadius: "8px",
            marginY: "16px",
            boxShadow: "none",
            border: "none",
            "&::before": {
              display: "none"
            }
          }}
        >
          <AccordionSummary
            sx={{ ".MuiAccordionSummary-content": { width: "100%", paddingX: "2px" } }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            {!expanded ? (
              <div style={{ width: "100%" }}>
                <Typography className="ellipse-one" variant={"label"} color={tokens.Text.General.Secondary}>
                  {filterList?.map((item: any) => {
                    return (
                      <>
                        <span style={{ marginRight: "1px", fontWeight: "700" }}>{item?.name}</span>
                        <span style={{ marginRight: "4px" }}>({item?.options?.length})</span>
                      </>
                    );
                  })}
                </Typography>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "row", gap: "24px", flexWrap: "wrap" }}>
                {filterList?.map((item: any) => {
                  return (
                    <div
                      key={uniqueId("CATEGORY")}
                      style={{ display: "flex", flexDirection: "column", maxWidth: "200px" }}
                    >
                      <Typography showBold color={tokens.Text.General.Secondary} variant={"label"}>
                        {item?.name}
                      </Typography>
                      {item?.options?.slice(0, getSliceNoToShowRecord(item)).map((item2: any, index: number) => {
                        return (
                          <React.Fragment key={uniqueId("OPTIONS_")}>
                            <Typography className="ellipse-one" variant={"label"}>
                              {item2}
                            </Typography>
                            {index === 9 &&
                              getSliceNoToShowRecord(item) < item?.options?.length &&
                              getMoreOrLessButton("See more", item, false)}
                            {index > 9 &&
                              index === item?.options?.length - 1 &&
                              getSliceNoToShowRecord(item) === item?.options?.length &&
                              getMoreOrLessButton("See less", item, true)}
                          </React.Fragment>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
          </AccordionSummary>
        </Accordion>
      )}
    </>
  );
};
export default FilterDescription;
